import FilterUtils from '@/shared/utils/filters';

export default class DiscountItemRuleRequest {
  id: string;

  discount: number | string;

  discountType: string;

  applyDiscount: boolean;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.discount = FilterUtils.formatValue(obj.discount) || 0;
    this.discountType = obj.discountType || '';
    this.applyDiscount = obj.applyDiscount || false;
  }

  public static of(obj: any = {}): DiscountItemRuleRequest {
    return new DiscountItemRuleRequest(obj || {});
  }

  public static ofList(obj: any[]): DiscountItemRuleRequest[] {
    return obj.map(this.of);
  }
}
